import { Button } from "@/components/catalyst/button";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { AlertDialog } from "@/lib/Components/Dialog/AlertDialog";
import {
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "@/components/catalyst/alert";

export function ConfirmSmallFleetDialog() {
  const { close, resolve, reject } = useDialogState<boolean>();

  return (
    <AlertDialog
      onClose={() => {
        reject?.(false);
      }}
    >
      <AlertTitle>This sign up is for rental companies</AlertTitle>
      <AlertDescription>
        Organisation accounts are for rental companies listing their fleet on
        Imoova. If you&apos;re a traveller looking to book a relocation, you
        don&apos;t need an organisation — you can book directly on imoova.com.
      </AlertDescription>
      <AlertActions>
        <Button
          outline
          onClick={() => {
            window.location.assign("https://www.imoova.com");
          }}
        >
          Book on imoova.com
        </Button>
        <Button
          onClick={async () => {
            await close();
            resolve?.(true);
          }}
        >
          I&apos;m a rental company
        </Button>
      </AlertActions>
    </AlertDialog>
  );
}
